import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeLabPdf extends IExportableFile {
    EncapsulatedDataId: string;
    LabfillerId?: string;
}

class FileTypeLabPdf extends ExportableFile implements IFileTypeLabPdf {
    public LabfillerId: string;
    public EncapsulatedDataId: string;

    constructor(fields: IFileTypeLabPdf) {
        super(FileType.LABPDF);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.EncapsulatedDataId; }

    public getCleanCopy(): FileTypeLabPdf {
        let copyConstructor: IFileTypeLabPdf = {
            EncapsulatedDataId: this.EncapsulatedDataId,
            LabfillerId: this.LabfillerId,
            date: this.date,
            description: this.description
        };

        return new FileTypeLabPdf(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        const fetchUrl = FileSelectionHelper.getFetchUrl(this.EncapsulatedDataId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }
}

export { FileTypeLabPdf };
